import PropTypes from 'prop-types'

// Internal components
import SymbolCard from '@/components/SymbolCard/SymbolCard'

const SymbolBlock = (props) => {
  const { data, matchMode, modifiers } = props
  const modifierClasses = modifiers && modifiers.length ? ' ' + modifiers.join(' ') : ''

  return (
    <div className={`SymbolBlock${modifierClasses}`}>
      <div className={'SymbolBlock-grid'}>
        {data.map((item, index) => {
          if (item?.link?.route === 'create/match/open' && !matchMode) return false
          return <SymbolCard {...item} count={index} key={`SymbolCard--${index}`} length={data.length} />
        })}
      </div>
    </div>
  )
}

SymbolBlock.propTypes = {
  data: PropTypes.array,
  matchMode: PropTypes.bool,
  modifiers: PropTypes.array
}

export default SymbolBlock
